/**
 * Logo TITAM — wordmark oficial do sistema (public/logos/logo_titam.png).
 *
 * Fonte ÚNICA da marca: toda tela que mostra a logo (sidebar, auth, onboarding,
 * docs, legal, páginas públicas) importa daqui. Trocar o arquivo abaixo troca a
 * marca no sistema inteiro.
 *
 * O PNG é preto sobre fundo transparente. Em fundo escuro use `invert` (ou a
 * classe CSS equivalente, quando o tema for decidido no CSS e não no JS).
 *
 * O arquivo já vem cortado na moldura (733x96, proporção ~7.6:1) — `height` é
 * a altura real do wordmark, sem folga transparente. A 14px o desenho ocupa
 * ~107px de largura.
 */

const LOGO_TITAM = '/logos/logo_titam.png'

/**
 * Símbolo TITAM (só o "A"), o mesmo arquivo usado como favicon em index.html.
 * Serve onde o wordmark não cabe — hoje, a sidebar recolhida. Manter os dois
 * apontando para o mesmo PNG é o que garante que aba e sidebar não divirjam.
 */
export const LOGO_MARK_TITAM = '/logos/favicon_titam.png'

export default function Logo({ height = 16, invert = false, className, style }) {
  return (
    <img
      src={LOGO_TITAM}
      alt="TITAM"
      className={className}
      style={{
        height,
        width: 'auto',
        display: 'block',
        ...(invert ? { filter: 'brightness(0) invert(1)' } : null),
        ...style,
      }}
    />
  )
}
